import { TenantAccountingSettings } from '../../../providers/User/User.model';
import { LoadLocation } from '../load/load.model';

export enum COMPANY_TYPE {
  CARRIER = 'CARRIER',
  CUSTOMER = 'CUSTOMER',
  DIVISION = 'DIVISION'
}

export interface Company {
  id: string;
  name: string;
  email_address?: string;
  phone?: string;
  phone_ext?: string;
  tenant_id?: string;
  company_type?: COMPANY_TYPE;
  poc_first_name?: string;
  poc_last_name?: string;
  location_id?: string | null;
  location?: LoadLocation | null;
  deleted_at?: Date;
  created_at?: Date;
  updated_at?: Date;
  created_by?: string;
  updated_by?: string;
  is_default_division?: boolean;
  tenant_accounting_settings: TenantAccountingSettings | null;
}
